module.exports = Promise.resolve(module.bundle.root("1o4C6"))